import _Object$keys from 'babel-runtime/core-js/object/keys';
var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _Object$keys(_vm.scenes).length > 0 ? _c('div', { staticClass: "switch-scene-wrap" }, _vm._l(_vm.innerScenes, function (item) {
    return _c('div', { key: item.scene, staticClass: "scene", class: { current: _vm.active === item.scene }, on: { "click": function click($event) {
          return _vm.$emit('switch', item);
        } } }, [_c('div', { staticClass: "scene-tt" }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', { staticClass: "scene-content" }, [_c('img', { attrs: { "src": item.image, "alt": item.name } })])]);
  }), 0) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };